import React from "react";
/**
 * Render the root element.
 *
 * @group Components
 * @see https://daypicker.dev/guides/custom-components
 */
export function Root(props) {
    return React.createElement("div", { ...props });
}
//# sourceMappingURL=Root.js.map